module.exports = __webpack_public_path__ + "static/ms-icon-144x144.9a189c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/ms-icon-144x144.png
// module id = 608
// module chunks = 114276838955818